import { SmartAssistant } from 'shared/interfaces/SmartAssistant';
import { TestCustomApiRequestDto, TestCustomApiRequestResultDto } from 'shared/interfaces/tools/CustomApiRequest';
import { ToolKind, UpdateAllToolConfigsDto } from 'shared/interfaces/tools/Tool';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const toolsBaseEndpoint = '/tools';

export const ToolsService = {
  updateAllToolConfigs: async (updateAllToolConfigsDto: UpdateAllToolConfigsDto): Promise<SmartAssistant> => {
    const response = await axiosBaseInstance({
      method: 'put',
      url: `${toolsBaseEndpoint}/configs`,
      data: updateAllToolConfigsDto
    });

    return response.data as SmartAssistant;
  },

  testCustomApiRequest: async (testRequest: TestCustomApiRequestDto): Promise<TestCustomApiRequestResultDto> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${toolsBaseEndpoint}/${ToolKind.CUSTOM_API_REQUEST}/test`,
      data: testRequest
    });

    return response.data as TestCustomApiRequestResultDto;
  }
};
